const CardGallery = (props) => {
    const { data } = props
    const participante = data.data;
    return (
        <div className="row justify-content-center">
            {participante.map((arbol, index) => {
                return (
                    <div key={index} className=" col-12 col-md-4 pb-4">
                        <div className="card text-center mb-4 mx-auto">
                            <div className="card-body">
                                <img src={arbol.picture} className="mx-auto card-img-center" alt="..." data-bs-toggle="modal" data-bs-target={"#modal" + index} />
                            </div>
                        </div>
                        <div className="modal fade" id={"modal" + index} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog  modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body overflow-auto">
                                        <h1 className="text-dark text-center">{arbol.name}</h1>
                                        <img src={arbol.picture} className="mx-auto text-center" alt="..." width="100%"></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            })}
        </div>
    )
}
export default CardGallery;